module.exports = __webpack_public_path__ + "static/media/support.d63ae08b.png";